import { z } from 'zod';
import { authUserSchema, passwordPolicySchema, userRoleSchema } from './auth.js';
/**
 * Contratos do CRUD de usuários do painel.
 *
 * Como em `auth`, os schemas descrevem o JSON que trafega: datas são strings
 * ISO, nunca `Date`. E `passwordHash` não aparece em lugar nenhum — o `omit`
 * global do Prisma já o remove na origem, e o contrato é a segunda barreira.
 */
/**
 * Usuário como o painel de administração o vê: tudo o que `authUserSchema`
 * tem, mais o que só interessa a quem gerencia contas.
 */
export const userSchema = authUserSchema.extend({
    isActive: z.boolean(),
    createdAt: z.iso.datetime(),
});
const nomeSchema = z
    .string()
    .trim()
    .min(2, 'Informe o nome completo.')
    .max(120, 'O nome tem no máximo 120 caracteres.');
const emailSchema = z
    .string()
    .trim()
    .min(1, 'Informe o e-mail.')
    .max(190, 'E-mail longo demais.')
    .pipe(z.email('E-mail inválido.'));
export const userCreateSchema = z.object({
    name: nomeSchema,
    email: emailSchema,
    password: passwordPolicySchema,
    role: userRoleSchema,
});
/**
 * Atualização parcial. Todo campo é opcional, mas pelo menos um precisa vir —
 * um corpo vazio é quase sempre engano de quem chama, e aceitar em silêncio
 * esconderia o erro.
 *
 * O e-mail não está aqui de propósito: trocá-lo muda a identidade de acesso da
 * conta e merece um fluxo próprio, com confirmação. Enquanto esse fluxo não
 * existir, criar outra conta é mais honesto do que renomear a chave em silêncio.
 */
export const userUpdateSchema = z
    .object({
    name: nomeSchema.optional(),
    role: userRoleSchema.optional(),
    isActive: z.boolean().optional(),
    password: passwordPolicySchema.optional(),
})
    .refine((valores) => Object.values(valores).some((v) => v !== undefined), {
    message: 'Informe ao menos um campo para alterar.',
});
/**
 * Paginação desde o começo, mesmo com poucos registros. Acrescentá-la depois
 * exige mexer no contrato, no cliente e na tela ao mesmo tempo.
 */
export const userListQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    perPage: z.coerce.number().int().positive().max(100).default(20),
});
export const userListSchema = z.object({
    items: z.array(userSchema),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    perPage: z.number().int().positive(),
});
//# sourceMappingURL=users.js.map